import Header from './components/Header';
import Home from './components/Home';
import { Toaster } from 'react-hot-toast';
import { useState } from 'react';

const App = () => {
	const [hunterVisible, setHunterVisibilitie] = useState(false);
	const [creatorModal, setCreatorModal] = useState(false);
	return (
		<div>
			<Toaster position='bottom-center' />
			<Header hunterVisible={hunterVisible} setHunterVisibilitie={setHunterVisibilitie} creatorModal={creatorModal} setCreatorModal={setCreatorModal} />
			<Home hunterVisible={hunterVisible} setHunterVisibilitie={setHunterVisibilitie} creatorModal={creatorModal} setCreatorModal={setCreatorModal} />
		</div>
	);
};

export default App;
